import LogActivityContent from "./LogActivityContent";

export default LogActivityContent;